// icons
import {
    Blocks,
    ChartNoAxesCombined,
    Cog,
    Wallet,
    MessageSquareCode,
    UserSearch
} from 'lucide-react';

// utils
import { PATHS } from '@/constants';

export default [
    {
        idn: 'dashboard',
        icon: <ChartNoAxesCombined />,
        path: PATHS.dashboard,
        label: 'Dashboard',
        isPrimary: true
    },
    {
        idn: 'sessions',
        icon: <MessageSquareCode />,
        path: PATHS.sessions,
        label: 'Sessions',
        isPrimary: true
    },
    {
        idn: 'contacts',
        icon: <UserSearch />,
        path: PATHS.contacts,
        label: 'Contacts',
        isPrimary: true
    },
    {
        idn: 'settings',
        icon: <Cog />,
        path: PATHS.settings,
        label: 'Settings',
        isPrimary: false
    },
    {
        idn: 'billing',
        icon: <Wallet />,
        path: PATHS.profile.billing,
        label: 'Billing',
        isPrimary: false
    },
    {
        idn: 'widgets',
        icon: <Blocks />,
        path: PATHS.widgets,
        label: 'Widgets',
        isPrimary: false
    }
];
